import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { sendBlast, resetSendStatus } from "../redux/notificationsSlice";
import "./AdminBlast.css";

// Admin controls → "Send notification blast": subject + body inputs, posted to
// POST /admin/blasts. The server persists the blast and broadcasts it to every
// connected client's bell; limits (120 / 2000) are enforced server-side too.
const SendBlastModal = ({ onClose }) => {
    const dispatch = useDispatch();
    const { sendStatus, sendError } = useSelector((state) => state.notifications);
    const [subject, setSubject] = useState("");
    const [body, setBody] = useState("");
    const closeTimer = useRef(null);

    const canSend =
        subject.trim().length > 0 && body.trim().length > 0 && sendStatus !== "pending";

    const submit = (e) => {
        e.preventDefault();
        if (!canSend) return;
        dispatch(sendBlast({ subject: subject.trim(), body: body.trim() }));
    };

    // Brief "Sent" confirmation, then close. Status resets on unmount so the next
    // open starts fresh (including after a failure).
    useEffect(() => {
        if (sendStatus === "sent") {
            closeTimer.current = setTimeout(onClose, 900);
        }
        return () => clearTimeout(closeTimer.current);
    }, [sendStatus, onClose]);

    useEffect(() => () => dispatch(resetSendStatus()), [dispatch]);

    return (
        <div className="admin-blast-overlay" onClick={onClose}>
            <div
                className="admin-blast-dialog"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <h3 className="admin-blast-title">Send notification blast</h3>
                <form className="admin-blast-form" onSubmit={submit}>
                    <label className="admin-blast-label" htmlFor="blast-subject">
                        Subject
                    </label>
                    <input
                        id="blast-subject"
                        className="admin-blast-input"
                        type="text"
                        maxLength={120}
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        autoFocus
                    />
                    <label className="admin-blast-label" htmlFor="blast-body">
                        Body
                    </label>
                    <textarea
                        id="blast-body"
                        className="admin-blast-textarea"
                        maxLength={2000}
                        rows={6}
                        value={body}
                        onChange={(e) => setBody(e.target.value)}
                    />
                    {sendStatus === "failed" && (
                        <div className="admin-blast-error">{sendError}</div>
                    )}
                    {sendStatus === "sent" && (
                        <div className="admin-blast-sent">Sent!</div>
                    )}
                    <div className="admin-blast-buttons">
                        <button
                            type="submit"
                            className="admin-blast-btn admin-blast-btn-send"
                            disabled={!canSend}
                        >
                            {sendStatus === "pending" ? "Sending…" : "Send"}
                        </button>
                        <button
                            type="button"
                            className="admin-blast-btn admin-blast-btn-cancel"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SendBlastModal;
